import {getLineNumberWidth} from '@github-ui/diffs/diff-line-helpers'
import {threadLineLocation, UnifiedDiffLines} from '@github-ui/diffs/DiffParts'
import {clsx} from 'clsx'

import type {ThreadSubject} from '../types'
import styles from './StaticUnifiedDiffPreview.module.css'

/**
 * Renders a static representation of a unified diff
 * Specifically for use in outdated threads, which return a slightly different set of difflines
 */
export function StaticUnifiedDiffPreview({
  subject,
  tabSize,
  hideHeaderDetails,
  className,
  diffTableClassName,
}: {
  subject?: ThreadSubject
  tabSize: number
  hideHeaderDetails?: boolean
  className?: string
  diffTableClassName?: string
}) {
  if (!subject?.diffLines || subject?.diffLines.length < 1) {
    return null
  }

  const lineWidth = getLineNumberWidth(subject.diffLines)

  return (
    <div className={clsx(styles.StaticDiffPreview, className)}>
      {!hideHeaderDetails && (
        <div className={styles.HeaderContainer}>
          <span className="text-small fgColor-muted">
            Line{' '}
            {threadLineLocation({
              originalStartLine: subject.originalStartLine,
              originalEndLine: subject.originalEndLine,
              startDiffSide: subject.startDiffSide,
              endDiffSide: subject.endDiffSide,
            })}
            , commit <code>{subject.pullRequestCommit?.commit.abbreviatedOid}</code>
          </span>
        </div>
      )}
      <UnifiedDiffLines
        lineWidth={lineWidth}
        lines={subject.diffLines}
        tabSize={tabSize}
        className={diffTableClassName}
      />
    </div>
  )
}

try{ StaticUnifiedDiffPreview.displayName ||= 'StaticUnifiedDiffPreview' } catch {}